import Header from './Header.vue';

export { Header };

export default Header;
